// src/config/deliveryLocations.js

export const DELIVERY_REGIONS = [
  "Eastern Region",
  "Entebbe Area",
  "Kampala Region",
  "Northern Region",
  "Rest Of Central Region",
  "Western Region",
];

/**
 * ✅ Fair shipping fees baseline (Region-level)
 * Assumption: you're using boda/SafeBoda style deliveries.
 * Kampala deliveries commonly land under ~10k UGX depending on distance/time. :contentReference[oaicite:1]{index=1}
 */
export const REGION_BASE_FEES = {
  "Kampala Region": 7000,
  "Entebbe Area": 9000,
  "Rest Of Central Region": 12000,
  "Eastern Region": 18000,
  "Western Region": 20000,
  "Northern Region": 25000,
};

// ✅ Sub-regions list per region
export const SUBREGIONS_BY_REGION = {
  // ✅ Kampala (from your screenshots)
  "Kampala Region": [
    "Bakuli",
    "Banda",
    "Biina",
    "Bugolobi",
    "Bukasa",
    "Bukesa",
    "Bukoto",
    "Bulenga",
    "Bunamwaya",
    "Bunga",
    "Busega",
    "Butabika",
    "Buwate",
    "Buziga",
    "Bwaise",
    "Bweyogerere",
    "Central Business District",
    "Down Town Kampala",
    "Ggaba",
    "Kabalagala",
    "Kaboja",
    "Kabowa",
    "Kabuusu",
    "Kagoma",
    "Kalerwe",
    "Kampala Industrial Area",
    "Kamwokya",
    "Kansanga",
    "Kanyanya",
    "Kasubi",
    "Katwe",
    "Kavule",
    "Kawaala",
    "kawanda / Kagoma",
    "Kawempe",
    "Kazo",
    "Kibiri",
    "Kibuli",
    "Kibuye",
    "Kigowa",
    "Kikaya",
    "Kikoni",
    "Kinawataka",
    "Kira",
    "Kireka",
    "Kirinya",
    "Kirombe",
    "Kisaasi",
    "Kisenyi",
    "Kisugu",
    "Kitante",
    "Kitebi",
    "Kitintale",
    "Kiwatule",
    "Kololo",
    "Komamboga",
    "Kulambiro",
    "Kyaliwajjala",
    "Kyambogo",
    "Kyanja",
    "Kyebando",
    "Kyengera",
    "Lubowa",
    "Lubya",
    "Lugala",
    "Lugoba",
    "Lugogo",
    "Lusaze",
    "Luwafu",
    "Luzira",
    "Lweza",
    "Maganjo",
    "Makerere",
    "Makindye",
    "Masanafu",
    "Mbalwa",
    "Mbuya",
    "Mengo",
    "Mpanga",
    "Mpererwe",
    "Mulago",
    "Munyonyo",
    "Mutundwe",
    "Mutungo",
    "Namungoona",
    "Namuwongo",
    "Nankulabye",
    "Nansana",
    "Nasser Road",
    "Nateete",
    "Ndeeba",
    "Ndejje",
    "Nsambya",
    "Ntinda",
    "Nyanama",
    "Old Kampala",
    "Rubaga",
    "Salaama",
    "Seguku",
    "Sonde",
    "Wakaliga",
    "Wandegeya",
    "Wankulukuku",
    "Zana",
  ],

  // ✅ Entebbe Area (from your screenshots)
  "Entebbe Area": [
    "Abayita Ababiri",
    "Akright City - Entebbe",
    "Banga",
    "Bugonga",
    "Entebbe Market Area",
    "Entebbe Town",
    "Katabi",
    "Kisubi",
    "Kitala",
    "Kitende",
    "Kitoro",
    "Kitubulu",
    "Kiwafu - entebbe",
    "Lunyo",
    "Manyago",
    "Nakiwogo",
    "Namulanda",
    "Nkumba",
    "Nsamuzi",
  ],

  // ✅ Rest Of Central Region (from your screenshots)
  "Rest Of Central Region": [
    "Bwikwe",
    "Gayaza",
    "Kajjansi",
    "Kalagi",
    "Kasangati",
    "Kayabwe",
    "Kayunga",
    "Kiboga",
    "Kikajjo",
    "lugazi",
    "Luweero",
    "Masaka",
    "Matugga",
    "Mityana",
    "Mpigi",
    "Mubende",
    "Mukono / Town Area",
    "Namanve",
    "Nsangi",
    "Nsasa",
    "Nyendo",
    "Seeta",
    "Wakiso",
    "wampewo",
    "Wobulenzi",
  ],

  // ✅ Eastern Region (from your screenshots)
  "Eastern Region": [
    "Bugembe",
    "Bugiri",
    "Bukedea",
    "Busia",
    "Buwenge",
    "Iganga",
    "Irundu",
    "Jinja",
    "Kagulu",
    "Kamuli",
    "Kidera",
    "Kumi",
    "Mafubira",
    "Mbale",
    "Mbikko",
    "Namungalwa",
    "Pallisa",
    "Serere",
    "Sironko",
    "Soroti",
    "Tirinyi",
    "Tororo",
  ],

  // ✅ Western Region (from your screenshots)
  "Western Region": [
    "Bushenyi",
    "Bweyale",
    "Hima",
    "Hoima",
    "Ibanda",
    "Kabale",
    "Kabarole (Fort Portal)",
    "Kabwohe",
    "Kagadi",
    "Kasese",
    "Kisoro",
    "Kyegegwa",
    "Kyenjojo",
    "Masindi",
    "Mbarara",
    "Ntungamo",
    "Rukungiri",
  ],

  // ✅ Northern Region (from your screenshots)
  "Northern Region": [
    "Adjumani",
    "Arua",
    "Dokolo",
    "Gulu",
    "Kalongo",
    "Kamdini",
    "Kitgum",
    "Koboko",
    "Lira",
    "Moyo",
    "Nebbi",
    "Oyam",
    "Paidha",
    "Pakwach",
    "Patongo",
  ],
};

// ✅ Adjustment (UGX) per sub-region (optional; 0 = no change)
export const SUBREGION_ADJUST = {
  // ✅ keep old key too (backwards compatibility)
  "Kampala (CBD)": -1000,

  // ✅ new screenshot name
  "Central Business District": -1000,

  Kawempe: 800,
  Rubaga: 1000,
  "Abayita Ababiri": 2000,
};

export const getSubRegions = (region) => {
  const key = String(region || "").trim();
  const list = SUBREGIONS_BY_REGION?.[key];
  return Array.isArray(list) ? list : [];
};

export const computeShipping = (region, subRegion, hasItems) => {
  if (!hasItems) return 0;

  const r = String(region || "").trim();
  const s = String(subRegion || "").trim();

  const base = Number(REGION_BASE_FEES?.[r] || 0) || 0;

  // ✅ allow old CBD label to map cleanly
  const normalizedSub =
    s === "Kampala (CBD)" ? "Central Business District" : s;

  const adj = Number(SUBREGION_ADJUST?.[normalizedSub] || 0) || 0;

  return Math.max(0, base + adj);
};
